export enum WebAppClientsEnum {
  wom = "wom",
  privilege = "privilege",
  sandbox = "sandbox",
  shiperto = "shiperto",
  entel = "entel",
}

export enum NoExistDeliveredStatusEnum {
  subStatus = "subStatus",
  statusEnd = "statusEnd",
}

export enum NoExistDeliveredResourcesEnum {
  customerOut = "final-status-courier",
  depleted = "final-status-courier",
  returnOPL = "final-status-courier",
  noDelivered = "final-status-courier",
}
